<template>
  <div v-if="show" class="whPageTopAlert">
    <div class="page-top-alert-style row-center-flex-style">
      <svg class="icon alert-icon-style" aria-hidden="true">
        <use xlink:href="#icon-top-alert"></use>
      </svg>
      <span class="page-top-alert-font-style">{{textValue}}</span>
      <el-button id="tour7" v-if="buttonName != null" class="page-top-alert-button-style" type="text" size="small" @click="handleClick">{{buttonName}}</el-button>
      <svg v-if="close" @click="closeAlert" class="icon alert-icon-close" aria-hidden="true">
        <use xlink:href="#icon-close"></use>
      </svg>
    </div>
  </div>
</template>

<script>
import "../../common/icon/iconfont.js";

export default {
  name: "PageTopAlert",
  data() {
    return {
      show: true,
    };
  },
  computed: {

  },
  components: {

  },
  props: {
    textValue: String,
    buttonName: String,
    close: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    closeAlert() {
      this.show = false;
    },
    handleClick() {
      this.$emit('buttonMethod');
    }
  },
};
</script>

<style lang="scss">
//页面顶部提示栏的样式
.page-top-alert-style {
  height: 48px;
  background-color: #FFF1F0;
  margin-bottom: 28px
}

//页面顶部提示栏图标的样式
.alert-icon-style {
  margin-left: 16px;
  margin-right: 8px;
}

//页面顶部提示栏关闭图标的样式
.alert-icon-close {
  cursor:pointer;
  margin-left: auto;
  margin-right: 16px;
}

//页面顶部提示栏文字的样式
.page-top-alert-font-style {
  color: #F5222D;
  font-size: 14px;
  line-height: 22px;
}

//页面顶部提示栏按钮文字的样式
.page-top-alert-button-style {
  padding-left: 4px !important;
  color: #F5222D !important;
  font-size: 14px !important;
  line-height: 22px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pageTopAlert/pageTopAlert.vue